<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_vii"></a><a id="frontmatter01"></a>ACKNOWLEDGMENTS</h2>
<p class="image1"><img alt="Image" src="images/line1.gif"/></p>
<p class="linespace"> </p>
<p class="para">My thanks to George Pelecanos and Walter Wager, two great writers whose advice and encouragement helped me all the way through. Thanks also to Ruth Cavin and Toni Plummer at St. Martin’s Press, and to Robert Randisi of the PWA. Many thanks to Peter Banks of the National Center for Missing and Exploited Children; Steve Hamilton; S. J. Rozan; Montgomery County, Maryland, Detective Terry Ryan (Ret.); Sari Horowitz, Scott Higham, and Peter Milius of <em>The Washington Post;</em> Willard Carroll; Matt Nicholl; Michael Cuddy; Larry Klein; Ed Read; Cass Peterson; Alexander Milenic; Patty Zubeck Means; Anne Morgan Gray; Kate Dell; Dr. Meg Chisolm; Maggie Magill; my wife, Katie, for her constant love and support of my writing despite a boatload of rejections; and our kids, Emma and James, who have congratulated me on not being able to take a hint.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?430a4fb8